import styled from "@emotion/styled";
import { css } from "../../utils/ide";

export const MessageBubble = styled.div(
  ({ theme, isUser }) => css`
    padding: 10px 14px;
    border-radius: 12px;
    max-width: 80%;
    line-height: 1.4;
    font-size: 14px;
    position: relative;
    align-self: ${isUser ? "flex-end" : "flex-start"};
    background-color: ${isUser
      ? "#5b6bfd"
      : theme.type === "light"
      ? theme.gray.gray100
      : theme.gray.gray800};
    color: ${isUser ? "white" : theme.text.primary};
    ${isUser
      ? css`
          white-space: pre-wrap;
        `
      : ""};

    p {
      margin: 0.5em 0;

      &:first-of-type {
        margin-top: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    pre {
      white-space: pre-wrap;
      background-color: ${isUser
        ? "rgba(255, 255, 255, 0.1)"
        : theme.type === "light"
        ? "rgba(0, 0, 0, 0.05)"
        : theme.gray.gray700};
      color: ${isUser
        ? "inherit"
        : theme.type === "dark"
        ? theme.blueGray.blueGray200
        : "inherit"};
      padding: 8px;
      border-radius: 4px;
      margin: 8px 0;
      font-size: 12px;
      overflow-x: auto;
    }

    code {
      background-color: ${isUser
        ? "rgba(255, 255, 255, 0.15)"
        : theme.type === "light"
        ? "rgba(0, 0, 0, 0.05)"
        : theme.gray.gray700};
      color: ${isUser
        ? "inherit"
        : theme.type === "dark"
        ? theme.blueGray.blueGray200
        : "inherit"};
      padding: 2px 4px;
      border-radius: 3px;
      font-family: monospace;
      font-size: 12px;
    }

    a {
      color: ${isUser ? "white" : theme.primary};
      text-decoration: underline;
    }

    ul,
    ol {
      margin: 8px 0;
      padding-left: 20px;
    }
  `
);
